import React from 'react';

import ModalNew from 'apps/auth/components/utils/ModalNew';

const GTSendModals = ({ modalRef }) => {
    return <ModalNew ref={modalRef} getComponent={(component) => component} />;
};
export default React.memo(GTSendModals);
